import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputTextarea } from 'primereact/inputtextarea';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';
import { EmaDataRowModel } from "../../../models/dataSynchronization";
import Spinner from '../../../common/components/spinner/spinner';
import DataSyncService from '../../../services/dataSyncService';
import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from 'primereact/inputswitch';
//import {Spinner} from 'primereact/spinner';
import { EmaDataRowContentModel } from '../../../models/dataSynchronization/emaDataRowContentModel'
import * as Constants from '../../../common/constants';
import * as Helperfunction from '../../../common/functions/helperFunctions';
import { enumToDropdownArray } from '../../../common/functions/helperFunctions';
import { DropdownModel } from "../../../models/dropdownModel";
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import { Dropdown } from 'primereact/dropdown';
import { EparDocContentConfig } from '../../../common/enums';

interface IProps {
    importClick: any,
    cancelClick: any,
    isVisible: boolean,
    currentRawData: EmaDataRowModel
}

interface IState {
    isLoading: boolean,
    error: any,
    currentRawData: EmaDataRowModel,
    validationMessage: string,
    selectedLangId: number,
    isNumOfDocsDiff: boolean,
    activeIndex: number,
    pathToFile: string,
    rowInFile: number,
    docConfigDropdown: Array<DropdownModel>,
}

class LoadDataAddEditDialog extends React.Component<IProps, IState> {
    dataSyncService = new DataSyncService();

    constructor(props: IProps) {
        super(props);

        let currentRawData: EmaDataRowModel = props.currentRawData;
        if (!currentRawData.numOfDocs || currentRawData.numOfDocs == 0) {
            currentRawData.numOfDocs = 1;
        }

        if (!this.props.currentRawData.rowContent) {
            const langKeys = HelperFunctions.getEnumKeys(Lang);

            let contentList = new Array<EmaDataRowContentModel>(0);
            langKeys.map(k => {
                let content = new EmaDataRowContentModel();
                content.langId = parseInt(Lang[k]);
                content.eparPlainText = '';
                contentList.push(content);
            });

            this.props.currentRawData.rowContent = contentList;
        }

        this.state = {
            isLoading: false,
            error: null,
            currentRawData: currentRawData,
            validationMessage: '',
            selectedLangId: Lang.bg,   //Lang.bg,
            isNumOfDocsDiff: props.currentRawData.isNumOfDocsDiff,
            activeIndex: 0,
            pathToFile: '',
            rowInFile: 0,
            docConfigDropdown: new Array<DropdownModel>(0),
        };
    }

    componentDidMount() {
        let pathFromLocalStorage = localStorage.getItem('pathToFile');
        if (pathFromLocalStorage && pathFromLocalStorage.trim() != '') {
            this.setState({ pathToFile: pathFromLocalStorage });
        }

        let docConfigDropdown: Array<DropdownModel> = [{ label: 'Select', value: -1 }].concat(enumToDropdownArray(EparDocContentConfig, true));
        this.setState({
            docConfigDropdown: docConfigDropdown,
        });
    }

    handleChange = (key, value) => {
        const currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
        currentRawData[key] = value;
        this.setState({ currentRawData: { ...currentRawData } });
    };

    isValidAddEditForm() {
        let message = '';

        this.setState({
            validationMessage: ''
        });

        if (!this.state.currentRawData.emaMedicineURL) {
            message += "Please enter EMA Medicine URL.<br />";
        }

        if (!this.state.currentRawData.medicineName) {
            message += "Please enter Medicine Name.<br />";
        }

        if (!this.state.currentRawData.commonINNnames) {
            message += "Please enter Common INN names.<br />";
        }

        if (!this.state.currentRawData.activeSubstances) {
            message += "Please enter Active Substances.<br />";
        }

        if (!this.state.currentRawData.productNumber) {
            message += "Please enter EMA product number.<br />";
        }

        // if (!this.state.currentRawData.numOfDocs) {
        //     message += "Please enter expected number of documents.<br />";
        // }

        this.setState({
            validationMessage: message
        });

        return message == '';
    }

    handleImportButton = event => {
        event.preventDefault();
        if (!this.isValidAddEditForm()) return;

        const currentRawData = this.state.currentRawData;
        //this.props.importClick(currentRawData);
        if (!currentRawData.rawDataSourceId || currentRawData.rawDataSourceId == 0) {
            //this.importSingleMedicineClick(currentRawData);
        }
        else {
            this.editClick(currentRawData);
        }
    }

    editClick = (rawData: EmaDataRowModel) => {
        this.setState({
            isLoading: true
        });

        this.dataSyncService.importSingleMedicinePlainText(rawData)
            .then(
                (data) => {
                    this.setState({
                        isLoading: false
                    });
                    this.props.cancelClick();
                },
                error => {
                    this.setState({
                        //isLoading: false,
                        error
                    }, () =>
                        this.fullGetAfterError(this.state.currentRawData.rawDataSourceId)
                    )
                }
            );
    }

    fullGetAfterError = (id: number) => {
        this.dataSyncService.getDataSourceFull(id).then(
            (data) => {
                this.setState({
                    isLoading: false,
                    currentRawData: data
                });
            },
            error => {
                this.setState({
                    isLoading: false,
                    error
                });
            }
        );
    }

    importSingleMedicineClick = (rawData: EmaDataRowModel) => {
        this.setState({
            isLoading: true
        });

        this.dataSyncService.importSingleMedicine(rawData)
            .then(
                (data) => {
                    this.setState({
                        isLoading: false
                    });
                    this.props.cancelClick();
                },
                error => {
                    this.setState({
                        isLoading: false,
                        error
                    });
                }
            );
    }

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    onLangChange = (lang) => {
        this.setState({ selectedLangId: lang });
    }

    handleChangeContent = (key, value) => {
        const currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
        currentRawData[key] = value;

        this.setState({ currentRawData: { ...currentRawData } });
    };

    handleChangeRowContent = (key, value) => {
        const rowData: EmaDataRowModel = { ...this.state.currentRawData };
        let content = rowData.rowContent.find(r => r.langId == this.state.selectedLangId);
        if (content) {
            content[key] = value;
        }
        this.setState({ currentRawData: { ...rowData } });
    };

    handleDocsSwitch = (e) => {

        let currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
        currentRawData.isNumOfDocsDiff = e.value;
        currentRawData.numOfLeaflets = 0;
        currentRawData.numOfSmPcs = 0;

        this.setState({
            currentRawData: currentRawData,
            isNumOfDocsDiff: e.value
        });
    }

    getValueContent = (key) => {
        let content = this.state.currentRawData.rowContent.find(r => r.langId == this.state.selectedLangId)
        if (content && content[key]) {
            return content[key];
        }
        return '';
    }

    setStateFromSingleLoad = (rawData: EmaDataRowModel) => {
        if (!rawData.rowContent) {
            const langKeys = HelperFunctions.getEnumKeys(Lang);

            let contentList = new Array<EmaDataRowContentModel>(0);
            langKeys.map(k => {
                let content = new EmaDataRowContentModel();
                content.langId = parseInt(Lang[k]);
                content.eparPlainText = '';
                contentList.push(content);
            });

            rawData.rowContent = contentList;
            rawData.numOfDocs = 1;

            this.setState({
                isLoading: false,
                currentRawData: rawData
            });
        }

        this.setState({
            isLoading: false,
            currentRawData: rawData
        });
    }

    handleLoadButton = () => {
        localStorage.setItem('pathToFile', this.state.pathToFile);

        let rowNum = this.state.rowInFile;

        this.dataSyncService.loadSingleRowFromPath(rowNum, this.state.pathToFile)
            .then(
                (data) => {
                    this.dataSyncService.getDataSourceFull(data).then(
                        (data) => {
                            this.setStateFromSingleLoad(data);
                        },
                        error => {
                            this.setState({
                                isLoading: false,
                                error
                            });
                        }
                    );
                },
                error => {
                    this.setState({
                        isLoading: false,
                        error
                    });
                }
            );
    }

    handleEparURLButtonCLick = (fileUrl: string) => {
        window.open(fileUrl);
    }

    handleDropdownChange = (key, value) => {
        const currentRawData: EmaDataRowModel = { ...this.state.currentRawData };
        currentRawData[key] = value;
        this.setState({ currentRawData: { ...currentRawData } });
    };

    public render() {

        const { currentRawData, selectedLangId, isLoading, error, docConfigDropdown } = this.state;

        return (

            <Dialog header="Import raw data (EMA)" responsive={true} width="50%"
                modal={true}
                visible={this.props.isVisible}
                onHide={this.handleCancelButton}
                footer={
                    <div>
                        <Button label="Import" icon="pi pi-check" onClick={this.handleImportButton} className="p-button-raised" />
                        <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
                    </div>}
            >
                <div style={{ minHeight: '450px', maxHeight: '770px' }}>
                    {isLoading ? <Spinner /> : null}
                    {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
                    {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                    <div style={{ maxWidth: 70 }}>
                        <Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
                    </div>

                    <div className="p-grid p-fluid p-md-12">
                        {!currentRawData || !currentRawData.rawDataSourceId || currentRawData.rawDataSourceId == 0 ?
                            <>
                                <div className="p-g-12 p-md-7">
                                    <label>Path to file:</label>
                                    <InputText
                                        onChange={(e) => this.setState({ pathToFile: e.target['value'] })}
                                        value={this.state.pathToFile ? this.state.pathToFile : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-3 p-6">
                                    <label>Row:</label>
                                    <InputText
                                        onChange={(e) => this.setState({ rowInFile: e.target['value'] })}
                                        value={this.state.rowInFile ? this.state.rowInFile : 0}
                                    />
                                </div>
                                <div className="p-g-12 p-md-2 p-6 mt-30">
                                    <Button label="Load" icon="pi pi-check" onClick={this.handleLoadButton} className="p-button-raised" />
                                </div>
                            </>
                            : null}
                        <div className="p-g-12 p-md-10">
                            <label>Ema Medicine URL:</label>
                            <InputText
                                onChange={(e) => this.handleChangeContent('emaMedicineURL', e.target['value'])}
                                value={currentRawData && currentRawData.emaMedicineURL ? currentRawData.emaMedicineURL : ""}
                            />
                        </div>
                        {currentRawData && currentRawData.emaMedicineURL ?
                            <>
                                <div className="p-g-12 p-md-1">
                                    <label>EPAR BG</label>
                                    <Button
                                        className="p-button-danger"
                                        icon="pi pi-file"
                                        onClick={() => this.handleEparURLButtonCLick(currentRawData.eparFileURLbg)}
                                    />
                                </div>
                                <div className="p-g-12 p-md-1">
                                    <label>EPAR EN</label>
                                    <Button
                                        className="p-button-danger"
                                        icon="pi pi-file"
                                        onClick={() => this.handleEparURLButtonCLick(currentRawData.eparFileURLen)}
                                    />
                                </div>
                            </> : null}
                        <div className="p-g-12 p-md-2">
                            <label>Expected docs:</label>
                            <InputText
                                onChange={(e) => this.handleChangeContent('numOfDocs', e.target['value'])}
                                value={currentRawData && currentRawData.numOfDocs ? currentRawData.numOfDocs : 0}
                            />
                        </div>
                        <div className="p-g-12 p-md-2">
                            <label>Docs num differs:</label>
                            <InputSwitch
                                onChange={(e) => this.handleDocsSwitch(e)}
                                checked={this.state.isNumOfDocsDiff}>
                            </InputSwitch>
                        </div>
                        <div className="p-g-12 p-md-2">
                            <label>Number of leaflets:</label>
                            <InputText
                                disabled={!this.state.isNumOfDocsDiff}
                                onChange={(e) => this.handleChangeContent('numOfLeaflets', e.target['value'])}
                                value={currentRawData && currentRawData.numOfLeaflets ? currentRawData.numOfLeaflets : 0}
                            />
                        </div>
                        <div className="p-g-12 p-md-2">
                            <label>Number of SmPCs:</label>
                            <InputText
                                disabled={!this.state.isNumOfDocsDiff}
                                onChange={(e) => this.handleChangeContent('numOfSmPcs', e.target['value'])}
                                value={currentRawData && currentRawData.numOfSmPcs ? currentRawData.numOfSmPcs : 0}
                            />
                        </div>
                        <div className="p-g-12 p-md-4">
                            <label>Docs config:</label>
                            <Dropdown
                                value={currentRawData && currentRawData.eparDocConfigId ? currentRawData.eparDocConfigId : -1}
                                options={docConfigDropdown}
                                onChange={(e) => this.handleDropdownChange('eparDocConfigId', e.value)}
                            />
                        </div>
                    </div>
                    <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                        <TabPanel header="Basic info">
                            <div className="p-grid p-fluid p-md-12">

                                <div className="p-g-12 p-md-12">
                                    <label>Medicine Name:</label>
                                    <InputText
                                        name="medicineName"
                                        onChange={(e) => this.handleChangeContent('medicineName', e.target['value'])}
                                        value={currentRawData && currentRawData.medicineName ? currentRawData.medicineName : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-12">
                                    <label>Common INN names:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('commonINNnames', e.target['value'])}
                                        value={currentRawData && currentRawData.commonINNnames ? currentRawData.commonINNnames : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-12">
                                    <label>Active Substances:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('activeSubstances', e.target['value'])}
                                        value={currentRawData && currentRawData.activeSubstances ? currentRawData.activeSubstances : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-6">
                                    <label>Product Number:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('productNumber', e.target['value'])}
                                        value={currentRawData && currentRawData.productNumber ? currentRawData.productNumber : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-6">
                                    <label>ATC Code:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('atcCode', e.target['value'])}
                                        value={currentRawData && currentRawData.atcCode ? currentRawData.atcCode : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-6">
                                    <label>Authorization Holder:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('authorizationHolderName', e.target['value'])}
                                        value={currentRawData && currentRawData.authorizationHolderName ? currentRawData.authorizationHolderName : ""}
                                    />
                                </div>
                                <div className="p-g-12 p-md-6">
                                    <label>Revision Date:</label>
                                    <InputText
                                        onChange={(e) => this.handleChangeContent('revisionDate', e.target['value'])}
                                        value={currentRawData && currentRawData.revisionDate ? currentRawData.revisionDate : ""}
                                    />
                                </div>
                            </div>
                        </TabPanel>
                        <TabPanel header="Plain Text">
                            <div className="p-grid p-fluid p-md-12">
                                <div className="p-g-12 p-md-12">
                                    <label>Plain Text:</label>
                                    <InputTextarea rows={15} cols={30}
                                        onChange={(e) => this.handleChangeRowContent('eparPlainText', e.target['value'])}
                                        value={this.getValueContent('eparPlainText')}
                                    />
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>
                </div >
            </Dialog >
        )
    }
}

export default LoadDataAddEditDialog;